// Alias
import Menu from '../private/menu';

export default Menu;



// WEBPACK FOOTER //
// ./components/lookup/menu/index.js